import * as React from "react";
import type { SVGProps } from "react";
const SvgSheetWithPen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={91}
    height={80}
    fill="none"
    viewBox="0 0 91 80" {...props}
  >
    <g clipPath="url(#sheet-with-pen_svg__a)">
      <path
        fill="url(#sheet-with-pen_svg__b)"
        d="m.89 35.167 30.6 43.041c.728 1.037 2.017 1.401 3.11.897L76.884 59.46c1.682-.784 2.158-3.138.981-4.651L46.23 14.43c-.729-.924-1.906-1.26-2.943-.84L2.066 30.6c-1.68.7-2.27 3.026-1.148 4.595z"
        opacity={0.7}
      />
      <path
        fill="#fff"
        stroke="#00217B"
        strokeMiterlimit={10}
        strokeWidth={0.56}
        d="M4.504 29.703c-.392.168-.56.7-.336 1.12 1.093 1.99 4.708 8.043 14.936 21.577 11.965 15.86 21.212 19.251 24.295 18.13L83.02 50.44c.589-.309 1.149-1.99-1.541-3.25-3.923-1.85-12.526-5.717-21.213-16.001-8.686-10.284-12.413-14.46-13.534-15.86-.196-.225-2.942-2.242-3.194-2.13z"
      />
      <path
        fill="#00217B"
        d="m32.778 18.046-17.681 7.398-2.382-3.11 6.613-2.747 1.821-.756 1.457-.617 1.71-.7 5.94-2.466z"
      />
      <path
        fill="#00217B"
        d="M21.261 14.684c-1.681 0-3.026 1.233-3.026 2.774s.42 1.597 1.065 2.13c.532.42 1.205.672 1.961.672 1.654 0 2.999-1.233 3.027-2.746v-.056c0-1.541-1.345-2.774-3.027-2.774m-.112 4.147c-.84-.056-1.541-.729-1.541-1.513 0-.785.757-1.514 1.653-1.514.897 0 1.654.673 1.654 1.514 0 .84-.113.644-.337.924l-1.457.617z"
      />
      <path
        fill="#7DADFF"
        d="M41.017 65.179c4.707-2.438 7.145-7.65 7.818-12.694.672-5.044.28-2.83.196-4.231s-.449-2.803-1.738-3.391c-1.26-.588-2.382.196-2.97 1.317s-1.009 2.578-1.233 3.895c-.42 2.578-.056 5.324 1.765 7.286.785.84 1.822 1.457 2.999 1.597s2.662-.308 3.755-1.065c1.821-1.261 3.054-3.306 3.502-5.464.449-2.158.28-2.298.085-3.419-.197-1.12-.617-2.606-1.934-2.578s-1.625 1.793-1.541 2.858.504 2.382 1.233 3.335c.728.953 1.71 1.653 2.886 1.933s2.382.084 3.447-.448.98-.616 1.373-1.037c.616-.644-.365-1.653-.981-.98-1.233 1.288-3.25 1.597-4.736.56s-1.26-1.317-1.54-2.13c-.281-.812-.253-.896-.281-1.373-.028-.476-.028-.84.14-1.205.168-.364.084-.168.056-.084s.028 0 .028 0c0 .056-.112-.112-.028 0s.112.14.168.224c.224.365.28.841.364 1.261.14.87.112 1.766-.056 2.634-.336 1.738-1.232 3.447-2.634 4.568-1.4 1.12-1.709 1.037-2.69 1.065s-1.681-.337-2.297-.925c-1.514-1.401-1.934-3.53-1.766-5.52s.42-2.354.84-3.447c.421-1.093.617-1.877 1.374-1.625.756.252 1.037 1.597 1.065 2.438.028 1.177 0 2.382-.168 3.559-.505 4.203-2.326 8.602-5.913 11.124-.42.28-.84.532-1.289.785-.813.42-.084 1.625.7 1.205z"
        opacity={0.4}
      />
      <path
        fill="#B0D2FF"
        d="M79.917 18.384 60.575 38.412c-.558.58-1.523 2.102-1.759 2.916L56.33 46.99l6.883-2.83c1.201-.88 2.08-1.694 2.638-2.294L84.634 21.75s-.15-1.673-1.758-3.002c-1.716-1.437-2.96-.365-2.96-.365"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.56}
        d="M78.566 20.057c.385.021.729.236 1.05.471a10.6 10.6 0 0 1 2.895 3.174"
      />
      <path
        fill="#000"
        d="M58.216 42.786s1.03-.407 1.908.493c.88.88.687 1.909.687 1.909l-4.482 1.822 1.887-4.202z"
      />
      <path
        stroke="#7DADFF"
        strokeMiterlimit={10}
        strokeWidth={0.841}
        d="m14.676 36.905 31.497-14.067M17.17 40.211l31.496-14.066M19.748 43.938l31.525-14.067M38.97 40.38l15.497-7.483"
        opacity={0.6}
      />
    </g>
    <defs>
      <linearGradient
        id="sheet-with-pen_svg__b"
        x1={11.174}
        x2={71.644}
        y1={11.376}
        y2={87.707}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#228FE6" />
        <stop offset={0.2} stopColor="#1AA0E0" />
        <stop offset={0.3} stopColor="#0DBBD6" />
        <stop offset={0.4} stopColor="#00DACB" />
        <stop offset={0.8} stopColor="#00DACB" stopOpacity={0.4} />
        <stop offset={1} stopColor="#00DACB" stopOpacity={0} />
      </linearGradient>
      <clipPath id="sheet-with-pen_svg__a">
        <path fill="#fff" d="M.33 0H90.67v79.357H.33z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSheetWithPen;
